import { createApiRef } from '@backstage/core-plugin-api';
import { RepoDeployInfo } from './types';

export interface StageDeployApi {
  getRepos(): Promise<RepoDeployInfo[]>;
  enableRepo(repoName: string, project?: string): Promise<{ prUrl: string; prNumber: number }>;
  disableRepo(repoName: string): Promise<{ prUrl: string; prNumber: number }>;
  simulateWebhook(repo: string, tag: string): Promise<{ updated: boolean }>;
}

export const stageDeployApiRef = createApiRef<StageDeployApi>({
  id: 'plugin.stage-deploy.api',
});
